import FirstPage from "../components/FirstPage/FirstPage";
import Footer from "../components/Footer/Footer";
import FourthPage from "../components/FourthPage/FourthPage";
import SecondPage from "../components/SecondPage/SecondPage";
import ThirdPage from "../components/ThirdPage/ThirdPage";
import LastPage from "../components/LastPage/LastPage";
import SecondPageMobile from "../components/SecondPage/SecondPageMobile";
import FourthPageMobile from "../components/FourthPage/FourthPageMobile";

const Main = () => {
    return (
        <>
            <FirstPage />
            <SecondPage />
            <SecondPageMobile />
            <ThirdPage />
            <FourthPage />
            <FourthPageMobile />
            <LastPage />
            <Footer />
        </>
    );
};

export default Main;
